import { render, staticRenderFns } from "./ModalVincularLaudosEmLote.vue?vue&type=template&id=008b9754&lang=pug"
import script from "./ModalVincularLaudosEmLote.vue?vue&type=script&lang=js"
export * from "./ModalVincularLaudosEmLote.vue?vue&type=script&lang=js"
import style0 from "./ModalVincularLaudosEmLote.vue?vue&type=style&index=0&id=008b9754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports